import ajaxPromise from 'common/js/AjaxPromises';
import { getEffectiveConnectionType } from 'common/js/connection';
import { DebugLog } from 'common/js/debug-log';
import { getOgAdContext } from 'common/js/environment-utils';

export function sendAdsEventsTrack(
  event: 'loaded' | 'loaded_error',
  adContext: AdContext,
  formatConfig: { isOgurySdk: boolean }
): Promise<void> {
  if (window.isOgyPreview || formatConfig.isOgurySdk) return Promise.resolve();

  const adTrackUrl = getOgAdContext().ad_track_url;
  if (!adTrackUrl) return Promise.resolve();

  const data = {
    apps_publishers: [adContext.apiKey],
    at: new Date().toISOString(),
    connectivity: getEffectiveConnectionType(),
    content: {
      event,
      advert: adContext.impressionId,
      advertiser: adContext.advertiserId,
      campaign: adContext.campaignId,
      ad_unit_id: adContext.adUnitId,
      pg: adContext.page,
      dmn: adContext.domain,
      dsp: adContext.dsp,
      a_ex: adContext._appExchange,
      creative_id: adContext.creativeId,
      t_u: adContext.isTemporaryUser
    },
    version: window.MRAID_ENV?.sdkVersion
  };

  DebugLog.log(`sendTrack: ${event}`, data);

  return ajaxPromise
    .postJson(adTrackUrl, data, {
      headers: {
        User: adContext.userId,
        'Instance-Token': adContext.userInstanceToken,
        'Device-OS': adContext.deviceOs
      }
    })
    .then(() => {
      DebugLog.log('sendAnalyticsTrack: event sent');
    });
}
